import React from "react"
import { flexBox, maxLines, responsiveFontSize } from "style/style_snippets"
import ScheduleIcon from "@mui/icons-material/Schedule"
import PlaceIcon from "@mui/icons-material/Place"
import EventIcon from "@mui/icons-material/Event"
import { Typography } from "@mui/material"

export const ArticleTitle = ({ title, additionalCss }) => {
  const articleTitleStyle = {
    ...additionalCss,
  }
  return (
    <Typography variant={"h3"} css={articleTitleStyle}>
      {title}
    </Typography>
  )
}

export const ArticleAuthorAndDate = ({ author, date, additionalCss }) => {
  const articleAuthorAndDateStyle = {
    ...maxLines(2),
    ...additionalCss,
  }
  return (
    <Typography variant={"body1"} css={articleAuthorAndDateStyle}>
      by {author}, {date}
    </Typography>
  )
}

export const ArticleReadingTime = ({ readingTime, additionalCss }) => {
  const articleReadingTimeStyle = {
    fontSize: responsiveFontSize(12, 14),
    color: "#9E9E9E",
    letterSpacing: 0.2,
    ...maxLines(2),
    ...additionalCss,
  }
  return <span css={articleReadingTimeStyle}>Reading time: {readingTime}</span>
}

export const ArticleTimeAndLocation = ({
  timeFrom,
  timeTo,
  place,
  additionalCss,
  date = null,
}) => {
  const articleDateAndLocationStyle = {
    ...flexBox.column,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    div: {
      ...flexBox.row,
      justifyContent: "flex-start",
      alignItems: "center",
      marginTop: "15px",
      span: {
        marginLeft: "20px",
      },
    },
    ...additionalCss,
  }
  return (
    <div css={articleDateAndLocationStyle}>
      {date && (
        <div>
          <EventIcon />
          <span>{date}</span>
        </div>
      )}
      <div>
        <ScheduleIcon />
        <span>
          {timeFrom} - {timeTo}
        </span>
      </div>
      <div>
        <PlaceIcon />
        <span>{place}</span>
      </div>
    </div>
  )
}
